export const CLICK = "Click";
export const ROLLOVER = "Rollover";
export const SCROLL = "Scroll";
export const TOUCH = "Touch";
